import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'not_found',
    templateUrl: './index.html',
    styleUrls: ['./style.scss']
})


export class NotFound implements OnInit  {

    completed:boolean = false;
    canceled:boolean = false;
    expired: boolean = true;

    constructor(
        private route: ActivatedRoute
    ) {}

    ngOnInit() {      
        if (this.route.snapshot.queryParams.status) {

            const storage = window.localStorage;     

            if ( this.route.snapshot.queryParams.status === "0") {

                storage.removeItem("completed");

                this.canceled = true;
                this.expired = false;
            } else {
              
                storage.removeItem("completed");

                this.completed = true;
                this.expired = false;
            }
        }  
    }
}
